import {Directive, forwardRef, Inject} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {Bban, BbanFormatter, isValidBban} from '@atlas/businesstypes';

import {
  ATLAS_VALUE_ACCESSOR,
  AtlasControlValueAccessor,
  BaseBusinesstypeDirective,
} from '../base/index';

/**
 * @ngModule BusinessTypesModule
 */
@Directive({
  selector: '[atlasBban]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => BbanDirective),
    },
  ],
})
export class BbanDirective extends BaseBusinesstypeDirective {
  public constructor(@Inject(ATLAS_VALUE_ACCESSOR) input: AtlasControlValueAccessor) {
    super(input);
  }

  public writeValue(value?: Bban | string): void {
    this._input.writeValue(
      Bban.isBban(value) ? BbanFormatter.format(value) : value == null ? '' : value,
    );
  }

  public registerOnChange(fn: (_: Bban | string | null) => void): void {
    this._input.registerOnChange(value => {
      if (value === '') {
        fn(null);
        return;
      }

      const unformatted = BbanFormatter.unformat(value);
      fn(isValidBban(unformatted) ? new Bban(unformatted) : unformatted);
    });
  }
}
